import { Section } from "@/components/layout-2/ds";
import { formatParis } from "@/utils/dialer-datetime";

export type EngineStateProps = {
    variables?: Record<string, unknown> | null;
    attempts?: Record<string, number> | null;
    suppressions?: Record<string, string> | null;
    /** The suspension the interpreter holds, when it holds one. */
    awaiting?: { token?: string | null; [key: string]: unknown } | null;
    defaultOpen?: boolean;
};

/**
 * The diagnosis view: collapsed because it is not the business's subject, present
 * because it saves a trip to the database.
 */
export function EngineState({ variables, attempts, suppressions, awaiting, defaultOpen = false }: EngineStateProps) {
    const attemptEntries = Object.entries(attempts ?? {});
    const suppressionEntries = Object.entries(suppressions ?? {});

    return (
        <Section icon="Cpu" title="Engine state" collapsible defaultCollapsed={!defaultOpen}>
            <div>
                <p className="text-xs text-gray-600">Attempts per step</p>
                {attemptEntries.length === 0 ? (
                    <p className="text-sm text-gray-500">None.</p>
                ) : (
                    <ul className="ml-4 list-disc text-sm">
                        {attemptEntries.map(([nodeId, count]) => (
                            <li key={nodeId}>
                                <span className="font-mono text-xs">{nodeId}</span> : <span className="tabular-nums">{count}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div>
                <p className="text-xs text-gray-600">Anti-spam keys</p>
                {suppressionEntries.length === 0 ? (
                    <p className="text-sm text-gray-500">None.</p>
                ) : (
                    <ul className="ml-4 list-disc text-sm">
                        {suppressionEntries.map(([key, expiry]) => (
                            <li key={key}>
                                <span className="font-mono text-xs">{key}</span> — expires {formatParis(expiry)}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div>
                <p className="text-xs text-gray-600">Workflow variables</p>
                <pre className="mt-1 max-h-48 overflow-auto rounded-sm border bg-gray-50 p-2 text-xs">{JSON.stringify(variables ?? {}, null, 2)}</pre>
            </div>
            {awaiting?.token != null && (
                <div>
                    <p className="text-xs text-gray-600">Awaiting token</p>
                    <pre className="mt-1 max-h-48 overflow-auto rounded-sm border bg-gray-50 p-2 text-xs">{JSON.stringify(awaiting, null, 2)}</pre>
                </div>
            )}
        </Section>
    );
}
